import React from 'react';
import Product from '../../../Types/Product';
import { translate } from '../../../Services/translation';
interface ProductInformationPanelProps {
  product: Product;
}

const ProductInformationPanel = ({
  product,
}: ProductInformationPanelProps) => {
  return (
    <div>
      <div className="mb-3 text-lg font-bold">
        {translate('detailed-product-card.product-information-title')}
      </div>
      <div className="flex flex-col gap-3">
        {product.productWidthM && (
          <div className="flex justify-between text-md text-gray-700">
            <span>{translate('product.product-width')}</span>
            <span>{`${product.productWidthM} ${translate(
              'general.unit-m'
            )}`}</span>
          </div>
        )}
        {product.productLengthM && (
          <div className="flex justify-between text-md text-gray-700">
            <span>{translate('product.product-length')}</span>
            <span>{`${product.productLengthM} ${translate(
              'general.unit-m'
            )}`}</span>
          </div>
        )}
        {product.productRepeatSizeCM && (
          <div className="flex justify-between text-md text-gray-700">
            <span>{translate('product.product-repeat-size')}</span>
            <span>{`${product.productRepeatSizeCM} ${translate(
              'general.unit-cm'
            )}`}</span>
          </div>
        )}
        {product.productPatternMatch && (
          <div className="flex justify-between text-md text-gray-700">
            <span>{translate('product.product-pattern-match')}</span>
            <span>{product.productPatternMatch}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductInformationPanel;
